<template>
  <div class="flex flex-row" :class="$style.root">
    <TrafficLocationsMap />
  </div>
</template>

<script>
import TrafficLocationsMap from '@/components/TrafficLocations/TrafficLocationsMap'

export default {
  name: 'TrafficLocations',

  components: {
    TrafficLocationsMap
  }
}
</script>

<style lang="postcss" module>
.root {
  height: calc(100vh - 48px);
}
</style>
